export const adPlacements = {
  dashboard: {
    titleKey: 'ads.dashboardTitle',
    bodyKey: 'ads.dashboardBody',
    ctaKey: 'ads.dashboardCta',
    href: '/worldcup/leaderboard',
  },
  predictions: {
    titleKey: 'ads.predictionsTitle',
    bodyKey: 'ads.predictionsBody',
    ctaKey: 'ads.predictionsCta',
    href: '/predictions',
  },
  groupDetails: {
    titleKey: 'ads.groupDetailsTitle',
    bodyKey: 'ads.groupDetailsBody',
    ctaKey: 'ads.groupDetailsCta',
    href: '/groups',
  },
};
